<template>
    <div class="container activity-details-container"   :class="{'subject-container':isSubject} ">
       <template v-if="!isSubject">
                <List :name="dName" ></List>
       </template>
        <template v-else >
                <Subject :name="dName" ></Subject>
       </template>
    </div>
</template>

<script>
    import List from '../components/activity/List';
    import Subject from "./subject/index";

    export default {
        data(){
            return {dName:"",isSubject:false }
        },
        components:{
            List,
            Subject
        },
        mounted(){
            this.dName=( this.$route&&this.$route.params&& this.$route.params.name) || '';
            if(this.dName==='xc'){
                this.dName='xcb'
                this.isSubject=true;
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>